import { apiClient } from '../../axios';
import { fetchClient } from '../../fetch';
import { Currency, CurrencyWarning } from './types';

export const fetchCurrenciesApi = () => fetchClient.fetch<{ currencies: Currency[] }>('/v1/currency/list');

export const getCurrenciesApi = () => apiClient.get<{ currencies: Currency[] }>('/v1/currency/list');

export const getCurrencyWarningsApi = () => apiClient.get<{ warnings: CurrencyWarning[] }>('/v1/currency/warnings');

export const postCurrencyLockApi = (currency: string, params: { amount: string }) =>
  apiClient.post<{ currency: string; amount: string }>(`/v1/currency/${currency}/lock`, params);

export const postCurrencyUnlockApi = (currency: string, params: { amount: string }) =>
  apiClient.post<{ currency: string; amount: string }>(`/v1/currency/${currency}/unlock`, params);
